import { all, fork } from 'redux-saga/effects'

import { blogSaga } from './blog/saga'
import { categorySaga } from './category/saga'
import { companySaga } from './company/saga'
import { productSaga } from './product/saga'
import { settingSaga } from './setting/saga'

export const combineSagas = (sagas: any[]) =>
  function* sagaCombiner() {
    try {
      yield all(sagas.map(fork))
    } catch (err) {
      console.error(err)
    }
  }

export const rootSaga = combineSagas([
  blogSaga,
  categorySaga,
  companySaga,
  productSaga,
  settingSaga
])
